import api from '../../../../../api/client';
import { AUCTION_REQUEST } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';
 
export async function getAuctionRequestList(params = {}) {
  try {
    const response = await api.get(AUCTION_REQUEST.LIST, { params });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
 
export async function getAuctionRequestDetail(ymsAuctionId) {
  try {
    const response = await api.get(AUCTION_REQUEST.DETAIL(ymsAuctionId));
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}